import { Directive, HostListener } from '@angular/core';
import { UIService } from '@bca-core/services/ui.service';

@Directive({
  selector: '[receiptFooterVisibility]'
})
export class ReceiptFooterVisibilityDirective {
  constructor(private _uiService: UIService) {}

  @HostListener('focus')
  onFocus(): void {
    this._uiService.showMobileReceiptFooter$.next(false);
  }

  @HostListener('focusout')
  onFocusOut(): void {
    this._uiService.showMobileReceiptFooter$.next(true);
  }
}
